module.exports = __webpack_public_path__ + "static/media/HeaderLogo.f6dc3ef2.svg";